import React, {useCallback, useMemo} from 'react';
import InRangeSelect from 'components/common/form/select/InRangeSelect';
import {useFormContext} from 'react-hook-form';
import {isLenderCredit} from 'lib/product';
import {useHomeSafeMetricsQuery} from 'query/products/home-safe/homesafe-metrics';
import {useTranslation} from 'lib/i18n';

IntroRatesSelect.propTypes = {};

function IntroRatesSelect(props) {
  const {defaultValue: defValue, ...rest} = props;
  const {t} = useTranslation();

  const {watch} = useFormContext();
  const [Lesa, LenderCredit] = watch(['Lesa', 'LenderCredit']);
  const [ProductId] = watch(['ProductId']);

  const {data: tiers = [], defaultTier} = useHomeSafeMetricsQuery({
    ProductId,
  });

  const getIntroLabel = useCallback(
    (tier = {}, lenderCreditOptions = {}) => {
      let {Rate = 0, OriginationFee = 0, Name = ''} = tier;
      const Fee = OriginationFee * 100;

      if (isLenderCredit(lenderCreditOptions)) {
        Rate = tier.LenderCredit;
      }

      return t('inputsTranslation:HomeSafeMetricId.valueFormat', {
        Name: Name.replace('_', ' '),
        Rate,
        count: Fee,
      });
    },
    [t],
  );

  const defaultValue = useMemo(
    () => defValue ?? defaultTier?.HomeSafeMetricId,
    [defValue, defaultTier?.HomeSafeMetricId],
  );

  const data = useMemo(
    () =>
      tiers
        .filter((tier) => (isLenderCredit({Lesa, LenderCredit}) ? tier.LenderCredit > 0 : true))
        .map((tier) => ({
          value: tier.HomeSafeMetricId,
          label: getIntroLabel(tier, {Lesa, LenderCredit}),
          selected: tier.HomeSafeMetricId === defaultValue,
        })),
    [tiers, defaultValue, getIntroLabel, Lesa, LenderCredit],
  );

  return <InRangeSelect {...rest} options={data} defaultValue={defaultValue} />;
}

export default IntroRatesSelect;
